(function () {
  function init() {
    var root = document.getElementById('lakoh-login');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true'; document.body.appendChild(root);
    var email = root.querySelector('input[type="email"]'), error = root.querySelector('.lakoh-login__error'), submit = root.querySelector('.lakoh-login__submit');
    var opener, previousOverflow;
    function valid() { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()); }
    function validate(showError) { var bad = !!email.value.trim() && !valid(); error.hidden = !(showError && bad); email.setAttribute('aria-invalid', showError && bad ? 'true' : 'false'); submit.disabled = !email.value.trim(); return valid(); }
    function open(event, trigger) { event.preventDefault(); event.stopImmediatePropagation(); if (!root.hidden) return; opener = trigger || event.currentTarget; previousOverflow = document.documentElement.style.overflow; var mobile = innerWidth < 768;
      var header = document.getElementById('pageheader');
      var bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 100;
      root.style.setProperty('--login-header-bottom', Math.min(bottom, innerHeight * .3) + 'px');
      root.hidden = false; document.documentElement.style.overflow = 'hidden';
      if (mobile) root.querySelector('.lakoh-login__close').focus(); else email.focus(); }
    function close() { root.hidden = true; document.documentElement.style.overflow = previousOverflow || ''; if (opener) opener.focus(); }
    document.querySelectorAll('#pageheader .sign a, #pageheader .sign-mobile a, #pageheader .header-account-link, #lakoh-mobile-nav .lmn-account').forEach(function (a) { a.addEventListener('click', open, true); });
    document.querySelectorAll('.lakoh-native-account__avatar').forEach(function (button) { button.addEventListener('click', open, true); });
    document.querySelectorAll('.mobileLogin').forEach(function (button) { button.addEventListener('click', open, true); });
    document.addEventListener('mouseover', function (event) {
      if (!root.hidden || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      var trigger = event.target.closest('#pageheader .sign a, #pageheader .sign-mobile a, #pageheader .header-account-link, #pageheader .lakoh-native-account__avatar, #pageheader .mobileLogin');
      if (trigger && !trigger.contains(event.relatedTarget)) open(event, trigger);
    });
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lakoh-login-open]');
      if (trigger) open(event, trigger);
    }, true);
    root.querySelector('.lakoh-login__close').addEventListener('click', close);
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    email.addEventListener('input', function () { validate(false); }); email.addEventListener('blur', function () { validate(true); });
    root.querySelector('form').noValidate = true;
    root.querySelector('form').addEventListener('submit', function (event) {
      if (!validate(true)) { event.preventDefault(); email.focus(); return; }
      event.preventDefault();
      var address = email.value.trim();
      try { sessionStorage.setItem('lakoh-login-email', address); } catch (_) {}
      var url = new URL(root.dataset.loginUrl, location.origin);
      url.searchParams.set('login_hint', address);
      location.assign(url.href);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') { var all = Array.from(root.querySelectorAll('button:not(:disabled), input, a[href]')); var first = all[0], last = all[all.length - 1]; if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); } }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
